// Spec 2026-10-06: foto/logo diminuida e comprimida NO APARELHO e guardada no
// banco como data URL -- sem Storage, funciona sem internet. A parte pura
// (tamanho, formato, validacao) e testada; prepararImagem usa o canvas.
export const LADO_MAXIMO = 400
export const LIMITE_PNG_BYTES = 80_000
export const ERRO_IMAGEM = 'Não foi possível usar essa imagem. Tente outra foto.'

export function tamanhoFinal(largura: number, altura: number, max = LADO_MAXIMO) {
  const escala = Math.min(1, max / Math.max(largura, altura))
  return { largura: Math.max(1, Math.round(largura * escala)), altura: Math.max(1, Math.round(altura * escala)) }
}

export function bytesDoDataUrl(dataUrl: string): number {
  const base64 = dataUrl.slice(dataUrl.indexOf(',') + 1)
  const sobra = base64.endsWith('==') ? 2 : base64.endsWith('=') ? 1 : 0
  return Math.floor((base64.length * 3) / 4) - sobra
}

export function usarPng(dataUrlPng: string, limite = LIMITE_PNG_BYTES): boolean {
  return bytesDoDataUrl(dataUrlPng) <= limite
}

// Revisao final: alguns seletores do Android entregam a foto SEM tipo -- quem
// decide e o decode, nao o rotulo.
export function tipoAceito(tipo: string): boolean {
  return tipo === '' || tipo.startsWith('image/')
}

// Revisao final: canvas que falha (memoria no celular) devolve "data:," --
// nunca gravar imagem vazia. `gerarJpeg` so roda quando o PNG passa do limite.
export function finalizarImagem(png: string, gerarJpeg: () => string): string {
  if (!logoValido(png)) throw new Error(ERRO_IMAGEM)
  if (usarPng(png)) return png
  const jpeg = gerarJpeg()
  if (!logoValido(jpeg)) throw new Error(ERRO_IMAGEM)
  return jpeg
}

export function logoValido(valor: unknown): valor is string {
  return typeof valor === 'string' && /^data:image\/(png|jpeg);base64,[A-Za-z0-9+/=]+$/.test(valor)
}

function carregar(arquivo: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(arquivo)
    const img = new Image()
    img.onload = () => { URL.revokeObjectURL(url); resolve(img) }
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error(ERRO_IMAGEM)) }
    img.src = url
  })
}

export async function prepararImagem(arquivo: File): Promise<string> {
  if (!tipoAceito(arquivo.type)) throw new Error(ERRO_IMAGEM)
  const img = await carregar(arquivo)
  if (!img.naturalWidth || !img.naturalHeight) throw new Error(ERRO_IMAGEM)
  const { largura, altura } = tamanhoFinal(img.naturalWidth, img.naturalHeight)
  const canvas = document.createElement('canvas')
  canvas.width = largura
  canvas.height = altura
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error(ERRO_IMAGEM)
  ctx.drawImage(img, 0, 0, largura, altura)
  return finalizarImagem(canvas.toDataURL('image/png'), () => {
    // JPEG nao tem transparencia: pinta o fundo de branco por baixo.
    ctx.globalCompositeOperation = 'destination-over'
    ctx.fillStyle = '#ffffff'
    ctx.fillRect(0, 0, largura, altura)
    return canvas.toDataURL('image/jpeg', 0.85)
  })
}
